import { useEffect, useState } from 'react'
import './manageDivisionDataTable.css';
import DataTable from '../DataTable/DataTable';
import AutoComplete from '../AutoComplete/AutoComplete';
import TextField from '@mui/material/TextField';

const ManageDivisionDataTable = ({ divisionData, isDataLoading, onEdit, userType }) => {
    const [divisionsData, setDivisionsData] = useState([]);
    const activityOptions = [
        { label: 'All', value: '' },
        { label: 'True', value: 'true' },
        { label: 'False', value: 'false' }
    ]

    const handleEditClick = (rowData) => {
        onEdit(rowData);
    };

    function isActiveFilterFn(row, columnId, filterValue) {
        if (!filterValue) return true; // no filter
        const rowValue = row.getValue(columnId);
        const filterValLower = filterValue.toLowerCase();
        if (filterValLower === 'true') return rowValue === true;
        if (filterValLower === 'false') return rowValue === false;
        return true;
    }

    const getIsActiveFilterValue = (column) => {
        const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
    }

    const columns = [
        {
            accessorKey: "divisionName",
            header: "Division",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "recruiterLeaderEmails",
            header: "Recruitment Leaders",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "teamNames",
            header: "Team",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "isActive",
            header: "Is Active",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: isActiveFilterFn,
            cell: ({ getValue }) => (getValue() ? "True" : "False"),
            Filter: ({ column }) => (
                <AutoComplete
                    disableClearable
                    className='isActiveFilter-autocomplete'
                    options={activityOptions}
                    value={getIsActiveFilterValue(column)}
                    onChange={(event, newValue) => {
                        column.setFilterValue(newValue ? newValue.value : '');
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                        />
                    )}
                    sx={{ width: '100%' }}
                />
            )
        },
        {
            id: "action",
            header: "Action",
            cell: ({ row }) => (
                <>
                    <button
                        className='editBtn_manageDivision'
                        disabled={userType === 'Admin' ? true : false}
                        onClick={() => handleEditClick(row.original)}
                    >
                        Edit
                    </button>
                </>
            ),
            size: 120,
            enableSorting: false,
            enableColumnFilter: false,
        },
    ]

    useEffect(() => {
        setDivisionsData(divisionData);
    }, [divisionData])

    return (
        <>
            <DataTable
                data={divisionsData}
                columns={columns}
                isLoading={isDataLoading}
                initialColumnFilters={[
                      {
                        id: 'isActive',
                        value: 'true'
                      }
                    ]}
            />
        </>
    )
}

export default ManageDivisionDataTable;
